"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TealiumEventLabel = exports.TealiumEventAction = exports.TealiumElement = exports.TealiumComponent = exports.TealiumFormat = exports.TealiumAction = exports.E_SIGN_INTERSTITIAL_TRY_AGAIN_BUTTON = exports.E_SIGN_INTERSTITIAL_ERROR = exports.E_SIGN_INTERSTITIAL_CLOSE_BUTTON = exports.E_SIGN_INTERSTITIAL_LOG_OUT_LINK = exports.E_SIGN_INTERSTITIAL_CONTINUE_BUTTON = exports.E_SIGN_INTERSTITIAL_ACCEPT_BUTTON = exports.E_SIGN_INTERSTITIAL_DOC_LINK = exports.E_SIGN_INTERSTITIAL_OPEN_MODAL = void 0;
exports.E_SIGN_INTERSTITIAL_OPEN_MODAL = 'E_SIGN_INTERSTITIAL_OPEN_MODAL';
exports.E_SIGN_INTERSTITIAL_DOC_LINK = 'E_SIGN_INTERSTITIAL_DOC_LINK';
exports.E_SIGN_INTERSTITIAL_ACCEPT_BUTTON = 'E_SIGN_INTERSTITIAL_ACCEPT_BUTTON';
exports.E_SIGN_INTERSTITIAL_CONTINUE_BUTTON = 'E_SIGN_INTERSTITIAL_CONTINUE_BUTTON';
exports.E_SIGN_INTERSTITIAL_LOG_OUT_LINK = 'E_SIGN_INTERSTITIAL_LOG_OUT_LINK';
exports.E_SIGN_INTERSTITIAL_CLOSE_BUTTON = 'E_SIGN_INTERSTITIAL_CLOSE_BUTTON';
exports.E_SIGN_INTERSTITIAL_ERROR = 'E_SIGN_INTERSTITIAL_ERROR';
exports.E_SIGN_INTERSTITIAL_TRY_AGAIN_BUTTON = 'E_SIGN_INTERSTITIAL_TRY_AGAIN_BUTTON';
var TealiumAction;
(function (TealiumAction) {
    TealiumAction["OPEN"] = "open";
    TealiumAction["CLICK"] = "click";
    TealiumAction["CONTINUE"] = "continue";
    TealiumAction["CLOSE"] = "close";
    TealiumAction["RETRY"] = "retry";
})(TealiumAction || (exports.TealiumAction = TealiumAction = {}));
var TealiumFormat;
(function (TealiumFormat) {
    TealiumFormat["MODAL"] = "modal";
    TealiumFormat["BUTTON"] = "button";
    TealiumFormat["LINK"] = "link";
    TealiumFormat["ICON"] = "icon";
})(TealiumFormat || (exports.TealiumFormat = TealiumFormat = {}));
var TealiumComponent;
(function (TealiumComponent) {
    TealiumComponent["E_SIGN_MODAL"] = "modal/tycEsignContract";
    TealiumComponent["E_SIGN_MODAL_ERROR"] = "modal/somethingWentWrong";
})(TealiumComponent || (exports.TealiumComponent = TealiumComponent = {}));
var TealiumElement;
(function (TealiumElement) {
    TealiumElement["FULL"] = "full";
    TealiumElement["ACCEPT"] = "accept";
    TealiumElement["CONTINUE"] = "continue";
    TealiumElement["SIGN_CONTRACT"] = "tycEsignContract";
    TealiumElement["LOG_OUT"] = "logOut";
    TealiumElement["CROSS"] = "cross";
    TealiumElement["TRY_AGAIN"] = "tryAgain";
})(TealiumElement || (exports.TealiumElement = TealiumElement = {}));
var TealiumEventAction;
(function (TealiumEventAction) {
    TealiumEventAction["SIGN_CONTRACT"] = "tycEsignContract";
    TealiumEventAction["CLICK_BUTTON"] = "clickButton";
    TealiumEventAction["SOMETHING_WENT_WRONG"] = "somethingWentWrong";
})(TealiumEventAction || (exports.TealiumEventAction = TealiumEventAction = {}));
var TealiumEventLabel;
(function (TealiumEventLabel) {
    TealiumEventLabel["OPEN"] = "open";
    TealiumEventLabel["SIGN_CONTRACT_LINK"] = "tycEsignContractLink";
    TealiumEventLabel["ACCEPT_BUTTON"] = "acceptButton";
    TealiumEventLabel["CONTINUE_BUTTON"] = "continueButton";
    TealiumEventLabel["LOG_OUT_LINK"] = "logOutLink";
    TealiumEventLabel["CLOSE"] = "close";
    TealiumEventLabel["TRY_AGAIN_BUTTON"] = "tryAgainButton";
})(TealiumEventLabel || (exports.TealiumEventLabel = TealiumEventLabel = {}));
//# sourceMappingURL=actions.constants.js.map